import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import ProductImageGallery from '../elements/product/ProductImageGallery';

const Product = () => {
    return (
        <>
            <SEO title="Products || KR Power" />
            <Layout>
                <BreadcrumbOne 
                    title="Our Products <br /> Quality Products for Your Needs"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Products"
                />

                <div className="main-content">
                    {/* Start Product Image Gallery Area  */}
                    <ProductImageGallery
                        subtitle="PRODUCT GALLERY"
                        title="Innovative Products, Trusted Performance.!"
                        description="A closer look at the products we manufacture and deliver."
                        sectionClass="rn-section-gap"
                    />
                    {/* End Product Image Gallery Area  */}
                </div>

            </Layout>
        </>
    )
}

export default Product
